"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = require("axios");
var queries = require("./queries");
var ShopifyKewl = /** @class */ (function () {
    function ShopifyKewl(config) {
        var _a = config || {
            store: null,
            storeFrontKey: null
        }, store = _a.store, _b = _a.graphPath, graphPath = _b === void 0 ? "/api/2019-07/graphql" : _b, storeFrontKey = _a.storeFrontKey;
        if (!store || !storeFrontKey) {
            throw new Error("Missing store or storefront key");
        }
        this.storeURL = store + ".myshopify.com";
        this.graphPath = graphPath;
        this.storeFrontKey = storeFrontKey;
        this.url = "https://" + this.storeURL + this.graphPath;
        this.config = {
            headers: {
                Accept: "application/json",
                "Content-Type": "application/graphql",
                "X-Shopify-Storefront-Access-Token": this.storeFrontKey
            }
        };
        this.queries = queries;
    }
    ShopifyKewl.prototype.query = function (query) {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, axios_1.default.post(this.url, query, this.config)];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res];
                }
            });
        });
    };
    ShopifyKewl.prototype.productByHandle = function (handle, fields) {
        return __awaiter(this, void 0, void 0, function () {
            var query, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        query = this.queries.productByHandle(handle, fields);
                        return [4 /*yield*/, this.query(query)];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, this.normalizeProduct(res.data.data.productByHandle)];
                }
            });
        });
    };
    ShopifyKewl.prototype.productsByHandle = function (handles, fields) {
        return __awaiter(this, void 0, void 0, function () {
            var products, _i, handles_1, handle, product;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        products = [];
                        _i = 0, handles_1 = handles;
                        _a.label = 1;
                    case 1:
                        if (!(_i < handles_1.length)) return [3 /*break*/, 4];
                        handle = handles_1[_i];
                        return [4 /*yield*/, this.productByHandle(handle, fields)];
                    case 2:
                        product = _a.sent();
                        products.push(product);
                        _a.label = 3;
                    case 3:
                        _i++;
                        return [3 /*break*/, 1];
                    case 4: return [2 /*return*/, products];
                }
            });
        });
    };
    ShopifyKewl.prototype.normalizeProduct = function (p) {
        var pro = p.node ? p.node : p;
        var images = [];
        var variants = [];
        var price = 0;
        var comparePrice = 0;
        var collections = [];
        var metafields = [];
        if (pro.images) {
            for (var _i = 0, _a = pro.images.edges; _i < _a.length; _i++) {
                var img = _a[_i];
                images.push(img.node.src);
            }
        }
        if (pro.metafields) {
            for (var _b = 0, _c = pro.metafields.edges; _b < _c.length; _b++) {
                var meta = _c[_b];
                metafields.push({ key: meta.node.key, value: meta.node.value });
            }
        }
        if (pro.collections) {
            for (var _d = 0, _e = pro.collections.edges; _d < _e.length; _d++) {
                var c = _e[_d];
                var collection = {
                    handle: c.node.handle,
                    title: c.node.title
                };
                collections.push(collection);
            }
        }
        if (pro.variants) {
            for (var _f = 0, _g = pro.variants.edges; _f < _g.length; _f++) {
                var v = _g[_f];
                var variant = {
                    available: v.node.available,
                    id: v.node.id,
                    image: v.node.image && v.node.image.src ? v.node.image.src : null,
                    price: Number(v.node.price) * 100,
                    compare_at_price: Number(v.node.compareAtPrice) * 100,
                    title: v.node.title
                };
                variants.push(variant);
            }
            price = Number(pro.variants.edges[0].node.price) * 100;
            comparePrice = pro.variants.edges[0].node.compareAtPrice ? Number(pro.variants.edges[0].node.compareAtPrice) * 100 : price;
        }
        var product = {
            id: pro.id ? pro.id : null,
            handle: pro.handle ? pro.handle : null,
            title: pro.title ? pro.title : null,
            images: images.length ? images : null,
            tags: pro.tags && pro.tags.length ? pro.tags : null,
            variants: variants.length ? variants : null,
            price: price,
            compare_at_price: comparePrice,
            collections: collections,
            metafields: metafields
        };
        return product;
    };
    ShopifyKewl.prototype.normalizeProducts = function (products) {
        var _this = this;
        return products.map(function (product) { return _this.normalizeProduct(product); });
    };
    return ShopifyKewl;
}());
exports.ShopifyKewl = ShopifyKewl;
